"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientFileRoutes = void 0;
var ClientFileRoutes;
(function (ClientFileRoutes) {
    ClientFileRoutes["BasePrefix"] = "client-files";
    ClientFileRoutes["ById"] = ":clientFileId";
    ClientFileRoutes["AllByClientId"] = "all/:clientId";
})(ClientFileRoutes = exports.ClientFileRoutes || (exports.ClientFileRoutes = {}));
